export type MsalFrameWindow = Pick<Window, 'location' | 'parent' | 'opener'>;

const AUTH_RESPONSE_PATTERN = /(^|[?#&])(code|error)=/;
const STATE_PATTERN = /(^|[?#&])state=/;

const hasAuthResponse = (fragment: string): boolean =>
  AUTH_RESPONSE_PATTERN.test(fragment) && STATE_PATTERN.test(fragment);

/**
 * True when this page was loaded by MSAL inside a hidden iframe (silent renewal)
 * or popup, carrying an auth response.
 *
 * msal-browser v5 requires such pages to hand the response back to the main frame
 * via `broadcastResponseToMainFrame()` instead of bootstrapping the app. Top-level
 * pages (including the `loginRedirect` return) are never matched.
 *
 * Popups are detected via `window.opener` only; COOP can sever that link. The app
 * uses no popup flows today — revisit if loginPopup/logoutPopup is ever added.
 */
export function isMsalChildFrameResponse(win: MsalFrameWindow): boolean {
  const isChildFrame = win.parent !== win || !!win.opener;
  if (!isChildFrame) {
    return false;
  }

  return hasAuthResponse(win.location.search) || hasAuthResponse(win.location.hash);
}
